/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PreviewDefaultPaymentPlans/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from '../helpers.js'
import CaseCloserPaymentPlans from 'DesignSystem/CaseCloserPaymentPlans/index'
import React from 'react'
import TysiaModal from 'DesignSystem/TysiaModal/index'
import TysiaModalContent from 'DesignSystem/TysiaModal/TysiaModalContent/index'
import TysiaModalHeader from 'DesignSystem/TysiaModal/TysiaModalHeader/index'
import TysiaModalHeaderCloseAction from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderCloseAction/index'
import TysiaModalHeaderTitle from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderTitle/index'



/** @type {import('Simple/types.js').View} */
export default function PreviewDefaultPaymentPlans({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Send/Content/Sidebar/Content/PreviewDefaultPaymentPlans"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let globalCurrentLocationIdValueData = fromData.useDataFormat({ viewPath,
context: 'global',
path: 'current_location._id',
format: fromFormat.asList,
})
let paymentPlanDiscountsValueData = fromData.useDataFormat({ viewPath,
context: 'payment_plan',
path: 'discounts',
format: fromHelpers.getPayorDiscounts,
})
let paymentPlanDiscountsValueData1 = fromData.useDataFormat({ viewPath,
context: 'payment_plan',
path: 'discounts',
format: fromHelpers.getTreatmentDiscounts,
})
let paymentPlanPayors0ShareAmountValueData = fromData.useDataValue({ viewPath,
context: 'payment_plan',
path: 'payors[0].share.amount',
})
let rulesetMaxDiscountValueData = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'max_discount',
})
let paymentPlanValueData = fromData.useDataValue({ viewPath,
context: 'payment_plan',
})
let aggregateData = fromHelpers.getMaxDiscount(rulesetMaxDiscountValueData, paymentPlanValueData)
  return (<React.Fragment
>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
 width={720}
 minHeight={600}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../Overview'))}
>
{childProps => (
<React.Fragment>
<TysiaModalHeader
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeader`}
>
{childProps => (
<React.Fragment>
<TysiaModalHeaderTitle
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderTitle`}
 text="Payment plan preview"
/>
<TysiaModalHeaderCloseAction
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderCloseAction`}
/>
</React.Fragment>
)}
</TysiaModalHeader>
<TysiaModalContent
{...childProps}
  viewPath={`${viewPath}/TysiaModalContent`}
 paddingTop={dtSpaceS}
 paddingBottom={dtSpaceS}
 paddingLeft={dtSpaceS}
 paddingRight={dtSpaceS}
 gap={dtSpaceS}
>
{childProps => (
<CaseCloserPaymentPlans
{...childProps}
  viewPath={`${viewPath}/CaseCloserPaymentPlans`}
 data="global.current_location._id"
 format="/Data/format.js asList"
 organizationIds={globalCurrentLocationIdValueData}
 showMockedOnEmptyPaymentPlans={false}
 data="payment_plan.discounts"
 format="../helpers.js getPayorDiscounts"
 payorDiscounts={paymentPlanDiscountsValueData}
 data="payment_plan.discounts"
 format="../helpers.js getTreatmentDiscounts"
 treatmentDiscounts={paymentPlanDiscountsValueData1}
 data="payment_plan.payors[0].share.amount"
 payorShare={paymentPlanPayors0ShareAmountValueData}
 data="ruleset.max_discount"
 data="payment_plan"
 aggregate="../helpers.js getMaxDiscount"
 maxDiscount={aggregateData}
/>
)}
</TysiaModalContent>
</React.Fragment>
)}
</TysiaModal>
{children}
</React.Fragment>)
}